module.exports = __webpack_public_path__ + "img/25.5aa831a8.png";